export enum InputType {
  /**
   * NPS input types
   * controles de 0 a 10
   */
  arrow = 'arrow',
  buttons = 'buttons',
  slider = 'slider',
  npsGradientButtonsColored = 'npsGradientButtonsColored',
  npsButtonsColored = 'npsButtonsColored',

  /**
   * eNPS input types
   * controles de 0 a 10
   */
  enpsArrow = 'enpsAarrow',
  enpsButtons = 'enpsButtons',
  enpsSlider = 'enpsSlider',
  enpsGradientButtonsColored = 'enpsGradientButtonsColored',
  enpsButtonsColored = 'enpsButtonsColored',

  /**
   * CSAT input types
   * controles de 1 a 5
   */
  csat = 'csat',
  csat5Stars = 'csat5Stars',
  csat5Buttons = 'csat5Buttons',

  /**
   * ESAT input types
   * controles de 1 a 5
   */
  esat = 'esat',
  esat5Stars = 'esat5Stars',
  esat5Buttons = 'esat5Buttons',

  /**
   * CSAT 10 input types
   * controles de 0 a 10
   */
  csat10 = 'csat10',
  csat10slider = 'csat10slider',
  csat10arrow = 'csat10arrow',

  /**
   * CES input types
   * controles de 1 a 7 com textos
   */
  ces = 'ces',
  cesButtons = 'cesButtons',
  cesStars = 'cesStars',

  /**
   * EES input types
   * controles de 1 a 7 com textos
   */
  ees = 'ees',
  eesButtons = 'eesButtons',
  eesStars = 'eesStars',
}

export type NpsInputTypes =
  | InputType.arrow
  | InputType.buttons
  | InputType.slider
  | InputType.npsGradientButtonsColored
  | InputType.npsButtonsColored;

export type EnpsInputTypes =
  | InputType.enpsArrow
  | InputType.enpsButtons
  | InputType.enpsSlider
  | InputType.enpsGradientButtonsColored
  | InputType.enpsButtonsColored;
